<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }} <span v-if="box.extra" class="extra_price"
                                                                                  v-bind:style="[(message !== '' ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ box.extra }} €</span>
        </div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div class="designer-select-dropdown">
                <div class="designer-select-dropdown-col">
                    <h3><span id="detail-name">Text</span></h3>
                    <div id="monogramm">
                        <input class="input-text" type="search" id="monogramm" maxlength=6 title="Monogramm"
                               name="Monogramm" v-model="message" @keyup="updatePersonalMonogramm">
                        <button class="reset-btn basic-bg" type="button" @click="resetMonogramm">X</button>
                    </div>
                </div>
                <div class="designer-select-dropdown-col">
                    <h3>Schriftart</h3>
                    <div id="monogramm_font" class="designer-select">
                        <select title="Schriftart" id="monogramm_font" name="Schriftart" v-model="fontselect"
                                @change="updatePersonalMonogramm">
                            <option value="block">Block</option>
                            <option value="italic">Kursiv</option>
                        </select>
                    </div>
                </div>

                <div class="designer-select-dropdown-col">
                    <h3>Position</h3>
                    <div id="monopos" class="designer-select">
                        <select title="Position" id="monopos" name="Position" v-model="selected"
                                @change="updatePersonalMonogramm">
                            <option value="waistleft">{{ translations['Waist left'] }}</option>
                            <option value="waistright">{{ translations['Waist right'] }}</option>
                            <option v-if="personal['sleeve']!='short' && personal['sleeve']!='shortbar'"
                                    value="cuffleft">{{ translations['Cuff left'] }}
                            </option>
                            <option v-if="personal['sleeve']!='short' && personal['sleeve']!='shortbar'"
                                    value="cuffright">{{ translations['Cuff right'] }}
                            </option>
                            <option value="collarleft">{{ translations['Collar left'] }}</option>
                            <option value="collarright">{{ translations['Collar right'] }}</option>
                            <option v-if="personal['bags']!='none' && personal['bagsposition']!='right'"
                                    value="pocketleft">{{ translations['Pocket left'] }}
                            </option>
                            <option v-if="personal['bags']!='none' && personal['bagsposition']!='left'"
                                    value="pocketright">{{ translations['Pocket right'] }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="designer-select-picturebox">
                <h3>Garn</h3>
                <div class="fabric-select-btn-box">
                    <div v-bind:class="[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]"
                         v-on:touchstart="touchstartup"v-on:mouseenter="scrollup" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
                        <div class="top-arrow-text"
                             v-bind:style="[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                            {{ translations['Scroll up for further fabrics'] }}
                        </div>
                    </div>
                    <div id="monogramm_yarn" class="fabric-select-btns" v-el:yarns @scroll="itemsScroll">

                        <div v-for="item in fabrics"
                             v-bind:class="[ 'fabric-select-btn', isactive === item.color_code ? 'active' : '' ]"
                             v-bind:data-yarncolor="item.color_code" @click="updatePersonal"
                             data-component="monogramm_yarn" v-bind:id="item.color_code">
                            <div class="fabric-select-img">
                                <span class="mask"></span>
                                <img v-bind:src="imgUrl(item.color_code)" v-bind:alt="item.name"
                                     v-bind:title="item.name"/>
                            </div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]"
                     v-on:touchstart="touchstartdown" v-on:mouseenter="scrolldown" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
                    <div class="bottom-arrow-text"
                         v-bind:style="[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                        {{ translations['Scroll down for further fabrics'] }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Monogramm',
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'translations', 'isactive', 'sleeve' ],
  data: function () {
    return {
      selected: (this.personal['monopos'] ? this.personal['monopos'] : ''),
      fontselect: (this.personal['monogramm_font'] ? this.personal['monogramm_font'] : ''),
      message: (this.personal['monogramm'] ? this.personal['monogramm'] : ''),
      personal: this.personal,
      images: [],
      image: window.shirtdesigner.image,
      scrolling: false,
      touchstart: false,
      scrollPosition: 0,
      translations: window.shirtdesigner.translations,
      selectedScrollHeight: (document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').scrollHeight : 0),
      selectedClientHeight: (document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').clientHeight : 0),
      isactive: (this.personal['monogramm_yarn'] ? this.personal['monogramm_yarn'] : 'neutral')
    }
  },
  methods: {
    updatePersonalMonogramm: function (event) {
      var value = ''
      switch (event.currentTarget.id) {
        case 'monogramm':
          value = this.message
          var check = value.replace(/\./g, '').length
          if (check > 3) {
            value = value.slice(0, -1)
            this.message = value
          }
          break
        case 'monopos':
          value = this.selected
          break
        case 'monogramm_font':
          value = this.fontselect
          break
        case 'monogramm_yarn':
          value = event.currentTarget.dataset.yarncolor
          break
        default:
          break
      }
      this.$dispatch('updatePersonalData', [event.currentTarget.id, value])
      /*global localStorage: false */
      var pos = (localStorage.getItem('monopos') ? JSON.parse(localStorage['monopos']) : 'waistleft')

      if (this.message !== '') {
        this.$dispatch('updateMonoPosition', pos)
      }
    },
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      if (typeof event.currentTarget.dataset.yarncolor !== 'undefined') {
        if (event.currentTarget.dataset.yarncolor !== 'neutral') {
          this.$dispatch('updatePersonalData', ['monogramm-color', event.currentTarget.dataset.yarncolor])
          this.$dispatch('updatePersonalData', ['monogramm_yarn', event.currentTarget.dataset.yarncolor])
          this.isactive = event.currentTarget.dataset.yarncolor
        } else {
          var rgb = this.colorFinder(document.getElementsByClassName('img-fit')[0])
          var neutralColor = this.componentToHex(rgb.r) + this.componentToHex(rgb.g) + this.componentToHex(rgb.b)
          this.$dispatch('updatePersonalData', ['monogramm-color', neutralColor])
          this.$dispatch('updatePersonalData', ['monogramm_yarn', 'neutral'])
          this.isactive = 'neutral'
        }
      }
    },
    resetMonogramm: function (event) {
      this.message = ''
      this.$dispatch('updatePersonalData', ['monogramm', this.message])
    },
    imgUrl: function (color) {
      if (color !== 'neutral') {
        return this.baseurl + 'designer/image/colorize/color/' + color + '/img/mask_buttonhole_yarn.png'
      } else {
        return this.baseurl + 'media/upload/image/dummy_product_small.jpg'
      }
    },
    scrolldown: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component + '_yarn')
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop + scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    scrollup: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component + '_yarn')
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop - scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    mouseleave: function () {
      if (this.scrolling) {
        window.clearInterval(this.scrolling)
        this.scrolling = false
      }
    },
    touchstartup: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component + '_yarn')
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop - scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchstartdown: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component + '_yarn')
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop + scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchend: function () {
      this.mouseleave()
    },
    colorFinder: function (imgEl) {
      var blockSize = 5 // only visit every 5 pixels
      var defaultRGB = {r: 0, g: 0, b: 0} // for non-supporting envs
      var canvas = document.createElement('canvas')
      var context = canvas.getContext && canvas.getContext('2d')
      var data
      var width
      var height
      var i = -4
      var length
      var rgb = {r: 0, g: 0, b: 0}
      var count = 0

      if (!context) {
        return defaultRGB
      }

      height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height
      width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width

      context.drawImage(imgEl, 0, 0)

      try {
        data = context.getImageData(0, 0, width, height)
      } catch (e) {
        /* security error, img on diff domain */
        return defaultRGB
      }
      length = data.data.length
      while ((i += blockSize * 4) < length) {
        ++count
        rgb.r += data.data[i]
        rgb.g += data.data[i + 1]
        rgb.b += data.data[i + 2]
      }

      // ~~ used to floor values
      rgb.r = ~~(rgb.r / count)
      rgb.g = ~~(rgb.g / count)
      rgb.b = ~~(rgb.b / count)

      return rgb
    },
    componentToHex: function (c) {
      var hex = c.toString(16)
      return hex.length === 1 ? '0' + hex : hex
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').clientHeight : 0)
    },
    itemsScroll: function () {
      var ele = document.getElementById(this.box.component + '_yarn')
      this.scrollPosition = ele.scrollTop
      this.checkMeasures()
    }
  },
  created: function () {
    this.message = (localStorage.getItem('monogramm') ? JSON.parse(localStorage['monogramm']) : '')
    if (this.message === 'no_monogramm') {
      this.message = ''
    }
    var pos = (localStorage.getItem('monopos') ? JSON.parse(localStorage['monopos']) : 'waistleft')
    this.$dispatch('updateMonoPosition', pos)
    this.isactive = (this.personal['monogramm_yarn'] ? this.personal['monogramm_yarn'] : 'neutral')
  },
  watch: {
    yarns: function () {
      this.checkMeasures()
    },
    filtertext: function () {
      this.checkMeasures()
    }
  },
  ready: function () {
    this.checkMeasures()
    this.$dispatch('runDesignJQuery')
  }
}
</script>


// WEBPACK FOOTER //
// Monogramm.vue?ca702a8a